import TextCell from 'components/TextCell';
import type { ManagedTeamsType } from '../..';

interface CellProps {
  rowData: ManagedTeamsType;
}

export default function ApiUserCell({ rowData: { apiUsername } }: CellProps) {
  return <TextCell text={apiUsername} />;
}
